import tippy from "tippy.js";

export function initLoginDropdown() {
  const triggerElement = document.querySelector("#login-dropdown-trigger");
  const contentElement = document.querySelector("#login-dropdown-content");
  if (!triggerElement || !contentElement) return;
  contentElement.classList.remove("header-actions__dropdown-content--hidden");

  tippy(triggerElement, {
    content: contentElement,
    interactive: true,
    trigger: "click",
    allowHTML: true,
    placement: "bottom-end",
    onMount() {},
  });
}
